import React from "react";
import { useTranslation } from "react-i18next";
import DeleteAccount from "./DeleteAccount";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";


const AccountSettings  = () => {
  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div
      className="rbt-header-sticky rbt-header-transpernt-active active-light-mode"
      dir={direction}
    >
      <section className="py-5">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  <h2 className="text-center fw-bold text-primary-custom mb-4">
                    {t("AccountSettings")}
                  </h2>
                  <p className="text-muted text-center mb-4">
                    {t(
                      "Here you can manage your account settings and find helpful resources."
                    )}
                  </p>
                </div>

                <div className="row g-5 px-4 pb-4">
                  {/* قسم تغيير كلمة المرور */}
                  <div className="col-lg-6">
                    <div className="rbt-dashboard-content bg-color-white rbt-shadow-box p-4">
                      <h5 className="mb-3">{t("ChangePassword.title")}</h5>
                     
                      <Alert variant="info">
                        {t("Change your password securely from here.")}
                      </Alert>
                      
                      <Link to="/change-password" className="btn btn-primary">
                        {t("Go to Change Password")}
                      </Link>
                    </div>
                  </div>

                  {/* قسم حذف الحساب */}
                  <div className="col-lg-6">
                    <div className="rbt-dashboard-content bg-color-white rbt-shadow-box p-4">
                      <h5 className="mb-3">{t("Delettion Account")}</h5>
                      <DeleteAccount />
                    </div>
                  </div>
                </div>

                {/* لاحقًا يمكن إضافة أقسام  */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AccountSettings ;
